import { render, staticRenderFns } from "./filePreview.vue?vue&type=template&id=2266daf5"
import script from "./filePreview.vue?vue&type=script&lang=js"
export * from "./filePreview.vue?vue&type=script&lang=js"
import style0 from "./filePreview.vue?vue&type=style&index=0&id=2266daf5&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports